import { HttpClient} from '@angular/common/http';
import { AppComponent} from '../app.component';
import { Component,	OnInit} from '@angular/core';
import qs from 'qs';
@Component({
  selector: 'app-about',
	templateUrl: './about.page.html',
	styleUrls: ['./about.page.scss'],
})
export class AboutPage implements OnInit {
	image: any = [];
	constructor(private http: HttpClient) {}

	public AppRef = AppComponent;

	ngOnInit() {
		this.fetchData();
	}

	fetchData() {
		const qr = qs.stringify(
			{
			  fields: [
				"id",
				"source",
				"timestamp"
			  ],
			  populate: {
				image: {
				  fields: ["url"],
				},
			  },
			},
			{
			encodeValuesOnly: true,
			}
		  );

		this.http.get(AppComponent.base + `/news-contents?${qr}`).subscribe((res) => {
			this.image = res['data'];
			this.image.forEach((element) => {
				element.image = AppComponent.base.substring(0,AppComponent.base.lastIndexOf('/')) + element.attributes.image.data.attributes.url;
			});	
		}, (err) => {
			console.log(err);
		});
	}
}